export const RoDetailsEmptyState = () => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center text-muted-foreground">
    <p className="text-sm font-medium">No RO selected</p>
    <p className="text-xs">
      Click a card on the board to see its details here.
    </p>
  </div>
);
